








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionShowButton
  }
})
export default class TicketTableActions extends Vue {
  @Prop({ required: true }) showPageLink: string
}
